import { Pipe, PipeTransform } from '@angular/core';
//import moment from 'proxies/dayjs';
import { AppService } from '../shared/services/app.service';
//import * as moment from 'moment-timezone';
import { UtilService } from '../services/util.service';
@Pipe({
    name: 'timeFormat',
    standalone: false
})
export class TimeFormatPipe implements PipeTransform {
  constructor(private appService: AppService, private utilService: UtilService) {}
  transform(time: any, timeFormat?: string): any {
    //let time_format = timeFormat ? timeFormat : this.appService._default_user_data['time_format']; 
    //let time_zone = timeFormat ? timeFormat : this.appService._default_user_data['timezone'];    
    return time != "0" ? this.utilService.toTimeZoneDateFormat(time, 'time'): ''; //this.utilService.toTimeZoneDate(time).format(`${time_format}`);
  }
}
